import { Link } from 'react-router-dom';
import { productDemoPath } from '../config/site';

export default function ProductCard({ product, variant = 'grid' }) {
  const isFlagship = product.isFlagship;
  const hasPage = Boolean(product.pagePath);
  const ctaHref = product.url || productDemoPath(product.id);
  const ctaExternal = Boolean(product.url);
  const isFeatured = variant === 'featured';
  const isCompact = variant === 'compact';

  return (
    <article
      className={`product-card product-card--${variant}${isFlagship ? ' product-card--flagship' : ''}${isFeatured ? ' product-card--featured' : ''}`}
      style={{ '--product-accent': product.accent }}
    >
      {product.heroImage && (
        <div className="product-card__visual">
          <img src={product.heroImage} alt={`${product.name} platform preview`} loading="lazy" />
        </div>
      )}
      <div className="product-card__body">
        {isFlagship && <span className="badge-flagship">Flagship · Live</span>}
        {product.demoAvailable && !isFlagship && (
          <span className="badge-demo">Enterprise · Demo available</span>
        )}
        <p className="product-card__category">{product.category}</p>
        <h3 className="product-card__name">{product.name}</h3>
        <p className="product-card__tagline">{product.tagline}</p>
        {isCompact && product.outcome ? (
          <p className="product-card__outcome">{product.outcome}</p>
        ) : (
          <p className="product-card__description">{product.description}</p>
        )}
        <div className="chip-row">
          {product.highlights.slice(0, 5).map((h) => (
            <span key={h} className="chip chip--product">
              {h}
            </span>
          ))}
        </div>
        <div className="product-card__actions">
          {hasPage ? (
            <Link to={product.pagePath} className="btn btn--product">
              Explore {product.name}
            </Link>
          ) : ctaExternal ? (
            <a
              href={ctaHref}
              className="btn btn--product"
              target="_blank"
              rel="noopener noreferrer"
            >
              {product.ctaLabel}
            </a>
          ) : (
            <Link to={ctaHref} className="btn btn--product">
              {product.ctaLabel}
            </Link>
          )}
          {hasPage ? (
            <Link to={productDemoPath(product.id)} className="btn btn--secondary">
              Request demo
            </Link>
          ) : isFlagship ? (
            <a href={product.url} className="btn btn--secondary" target="_blank" rel="noopener noreferrer">
              Learn more
            </a>
          ) : null}
        </div>
      </div>
    </article>
  );
}
